import { render, staticRenderFns } from "./LayerSwitcher.vue?vue&type=template&id=58833d5c&scoped=true"
import script from "./LayerSwitcher.vue?vue&type=script&lang=js"
export * from "./LayerSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LayerSwitcher.vue?vue&type=style&index=0&id=58833d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58833d5c",
  null
  
)

export default component.exports